export class UnsupportedAttachmentError extends Error {}

function base64ToBlob(base64: string, contentType: string): Blob {
  const byteChars = atob(base64);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  return new Blob([new Uint8Array(byteNumbers)], {
    type: contentType || "application/octet-stream",
  });
}

export function getAttachmentBlob(
  item: Office.MessageRead,
  attachmentId: string,
  contentType: string
): Promise<Blob> {
  return new Promise((resolve, reject) => {
    item.getAttachmentContentAsync(attachmentId, (asyncResult) => {
      if (asyncResult.status === Office.AsyncResultStatus.Failed) {
        reject(new Error(asyncResult.error.message));
        return;
      }

      const { format, content } = asyncResult.value;

      if (format !== Office.MailboxEnums.AttachmentContentFormat.Base64) {
        reject(new UnsupportedAttachmentError(`Unsupported attachment format: ${format}`));
        return;
      }

      try {
        resolve(base64ToBlob(content, contentType));
      } catch (error) {
        reject(error instanceof Error ? error : new Error(String(error)));
      }
    });
  });
}
